import { render } from "./AboutUsView.vue?vue&type=template&id=52959a5c&scoped=true"
import script from "./AboutUsView.vue?vue&type=script&lang=js"
export * from "./AboutUsView.vue?vue&type=script&lang=js"

import "./AboutUsView.vue?vue&type=style&index=0&id=52959a5c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52959a5c"]])

export default __exports__